export const SEARCH_CHANNEL_ACTIVATION = "SEARCH_CHANNEL_ACTIVATION";
export const SEARCH_CHANNEL_ACTIVATION_SUCCESSFULL = "SEARCH_CHANNEL_ACTIVATION_SUCCESSFULL";
export const SEARCH_CHANNEL_ACTIVATION_REPORT_FAILED = "SEARCH_CHANNEL_ACTIVATION_REPORT_FAILED";
export const RESET_CHANNEL_ACTIVATION_REPORT_PAGE="RESET_CHANNEL_ACTIVATION_REPORT_PAGE";